import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  AreaChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Area,
} from 'recharts';

const UserOverviewChart = ({
  data,
  selectedMonth,
  selectedYear,
  onMonthChange,
  onYearChange,
  Overview,
}) => {
  return (
    <div className="p-4 font-nohemi h-[90%]">
      {/* Header with Dropdown */}
      <div className="flex flex-row justify-between border-b-2 border-[#E5E7E8] pb-2">
        <p className="font-nohemi font-normal text-base text-[#191B1C]">{Overview}</p>
        <div className="flex space-x-2 ">
          {/* Month Dropdown */}
          <select
            className="border rounded p-1 text-sm text-[#4A5154] bg-[#F5F6F7]"
            value={selectedMonth}
            onChange={e => onMonthChange(Number(e.target.value))}>
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(2025, i))}
              </option>
            ))}
          </select>

          {/* Year Dropdown */}
          <select
            className="border rounded p-1 text-sm text-[#4A5154] bg-[#F5F6F7]"
            value={selectedYear}
            onChange={e => onYearChange(Number(e.target.value))}>
            {Array.from({ length: 5 }, (_, i) => {
              const year = new Date().getFullYear() - i;
              return (
                <option key={year} value={year}>
                  {year}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      {/* Chart */}
      <ResponsiveContainer width="100%">
        <AreaChart data={data} margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorVisits" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0066FF" stopOpacity={0.2} />
              <stop offset="95%" stopColor="#0066FF" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#E5E7E8" />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 12, fill: '#8A9296' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 12, fill: '#8A9296' }}
            tickFormatter={value => (value === 0 ? '00' : value)}
            scale="log"
            domain={['auto', 'auto']}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip
            contentStyle={{
              fontSize: '12px',
              backgroundColor: 'white',
              borderRadius: '4px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: 'none',
            }}
          />
          <Area
            type="monotone"
            dataKey="totalVisits"
            stroke="#0066FF"
            strokeWidth={2}
            fill="url(#colorVisits)"
            activeDot={{ r: 6, fill: '#0066FF', stroke: 'white', strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

UserOverviewChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  Overview: PropTypes.string.isRequired,
  selectedMonth: PropTypes.number.isRequired,
  selectedYear: PropTypes.number.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
};

export default UserOverviewChart;
